import { CircularProgress, Stack } from "@material-ui/core";

type LoadingOverlayProps = {
  isLoading: boolean;
};

export function LoadingOverlay({ isLoading }: LoadingOverlayProps): JSX.Element {
  if (!isLoading) return null;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      zIndex={2}
      sx={{
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.8)"
      }}
    >
      <CircularProgress />
    </Stack>
  );
}
